document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".cs-form").forEach(form => {

    const subjectField = form.querySelector("[name='subject']");
    const orderField = form.querySelector("[name='order_number']");
    const fileField = form.querySelector("[name='file']");

    const orderWrapper = orderField?.closest(".cs-field");
    const fileWrapper = fileField?.closest(".cs-field");

    // Convert CSV → array
    function parseList(str) {
      return (str || "")
        .split(",")
        .map(s => s.trim())
        .filter(Boolean);
    }

    const orderRequiredList = parseList(form.dataset.orderRequired);
    const fileRequiredList = parseList(form.dataset.fileRequired);

    function handleConditionalFields() {
      const selected = subjectField.value;

      // 🔹 ORDER NUMBER
      if (orderRequiredList.includes(selected)) {
        orderField.setAttribute("required", "required");
        orderWrapper?.classList.add("required-active");
      } else {
        orderField.removeAttribute("required");
        orderWrapper?.classList.remove("error");
        orderWrapper?.classList.remove("required-active");
      }

      // 🔹 FILE UPLOAD
      if (fileRequiredList.includes(selected)) {
        fileField?.setAttribute("required", "required");
        fileWrapper?.classList.add("required-active");
      } else {
        fileField?.removeAttribute("required");
        fileWrapper?.classList.remove("error");
        fileWrapper?.classList.remove("required-active");
      }
    }

    subjectField.addEventListener("change", handleConditionalFields);

    // Run once on load (in case default selected)
    handleConditionalFields();

    const modal = document.getElementById(`cs-modal-${form.id.replace('cs-form-','')}`);
    const messageField = form.querySelector("[name='message']");
    const charCount = form.querySelector(".cs-char-count");

    function updateCharCount() {
      const max = 500;
      let value = messageField.value;

      if (value.length > max) {
        messageField.value = value.substring(0, max);
      }

      const remaining = max - messageField.value.length;
      charCount.textContent = `${remaining} characters left`;
    }

    messageField.addEventListener("input", updateCharCount);

    // initialize
    updateCharCount();

    function showModal(type) {
      const titleEl = modal.querySelector(".cs-modal-title");
      const msgEl = modal.querySelector(".cs-modal-message");

      if (type === "success") {
        titleEl.textContent = titleEl.dataset.successTitle;
        msgEl.textContent = msgEl.dataset.successMessage;
      } else {
        titleEl.textContent = titleEl.dataset.errorTitle;
        msgEl.textContent = msgEl.dataset.errorMessage;
      }

      modal.classList.add("active");
    }

    function validate(field) {
      const wrapper = field.closest(".cs-field");

      // skip if NOT required
      if (!field.hasAttribute("required")) {
        wrapper.classList.remove("error");
        return true;
      }

      //  FILE FIELD
      if (field.type === "file") {
        const MAX_SIZE = 10 * 1024 * 1024;

        if (field.files.length === 0) {
          wrapper.classList.add("error");
          return false;
        }

        if (field.files[0].size > MAX_SIZE) {
          wrapper.classList.add("error");

          const errorEl = wrapper.querySelector(".cs-error");
          if (errorEl) {
            errorEl.textContent = "File size must be less than 10MB";
          }

          return false;
        }
      }
      //  OTHER FIELDS
      else {
        if (!field.value.trim()) {
          wrapper.classList.add("error");
          return false;
        }

          //  NAME VALIDATION (only letters + space)
          if (field.name === "first_name" || field.name === "last_name") {
            const nameRegex = /^[A-Za-z\s]+$/;

            if (!nameRegex.test(field.value.trim())) {
              wrapper.classList.add("error");

              const errorEl = wrapper.querySelector(".cs-error");
              if (errorEl) {
                errorEl.textContent = "Only letters are allowed";
              }

              return false;
            }
          }

        if (field.type === "email") {
          const valid = /^[A-Za-z0-9]+([._+-]?[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/.test(field.value);
          if (!valid) {
            wrapper.classList.add("error");
            return false;
          }
        }
      }

      wrapper.classList.remove("error");
      return true;
    }

    form.querySelectorAll("input, textarea, select").forEach(el => {
      el.addEventListener("blur", () => validate(el));

      if (el.type === "file") {
        el.addEventListener("change", () => validate(el));
      }
    });

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      let valid = true;

      form.querySelectorAll("[required]").forEach(el => {
        if (!validate(el)) valid = false;
      });

      if (!valid) return;

      const submitBtn = form.querySelector("button[type='submit']");
      submitBtn.classList.add("loading");
      submitBtn.disabled = true;


      let fileData = null;

      if (fileField && fileField.files.length > 0) {
        const file = fileField.files[0];

        const MAX_SIZE = 10 * 1024 * 1024; // 10MB

        if (file.size > MAX_SIZE) {
          const wrapper = fileField.closest(".cs-field");
          wrapper.classList.add("error");

          const errorEl = wrapper.querySelector(".cs-error");
          if (errorEl) {
            errorEl.textContent = "File size must be less than 10MB";
          }

          
          submitBtn.classList.remove("loading");
          submitBtn.disabled = false; 

          return; //  stop submission
        }

        fileData = await new Promise((resolve) => {
          const reader = new FileReader();

          reader.onload = () => {
            resolve({
              name: file.name,
              type: file.type,
              content: reader.result.split(",")[1]
            });
          };

          reader.readAsDataURL(file);
        });
      }

      const formData = {
        subject: form.querySelector("[name='subject']").value,
        first_name: form.querySelector("[name='first_name']").value,
        last_name: form.querySelector("[name='last_name']").value,
        email: form.querySelector("[name='email']").value,
        order_number: form.querySelector("[name='order_number']").value,
        message: form.querySelector("[name='message']").value,
        recipient_email: form.dataset.email,
        file: fileData
      };

  

      try {
        const response = await fetch("https://script.google.com/macros/s/AKfycbwy3v_WoKCm2T6UEvdmdBdl5R_LBSrJBCnbGwK6pUNVxwW2NpVcEWurRwtX4TxPyw7s9w/exec", {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "text/plain"
          }
        });

        const text = await response.text();
        console.log("RAW RESPONSE:", text);

        let result;
        try {
          result = JSON.parse(text);
        } catch {
          throw new Error("Invalid JSON response");
        }

        if (result.success) {
          form.reset();
          handleConditionalFields(); // reset required UI
          updateCharCount();
          showModal("success");
        } else {
          console.error(result.error);
          showModal("error");
        }

      } catch (err) {
        console.error("Fetch failed:", err);
        showModal("error");
      }

      submitBtn.classList.remove("loading");
      submitBtn.disabled = false;
    });
    

    modal.querySelector(".cs-close").onclick = () => modal.classList.remove("active");
    modal.querySelector(".cs-modal-btn").onclick = () => modal.classList.remove("active");

  });

});